const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

function parsearFecha(fecha) {
  if (!fecha) return null;

  const texto = String(fecha).trim();
  if (!texto) return null;

  if (/^\d{4}-\d{2}-\d{2}/.test(texto)) {
    const [y, m, d] = texto.split('T')[0].split('-').map((v) => parseInt(v, 10));
    if (y && m && d) return { dia: d, mes: m, anio: y };
  }

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(texto)) {
    const [d, m, y] = texto.split('/').map((v) => parseInt(v, 10));
    if (y && m && d) return { dia: d, mes: m, anio: y };
  }

  const parsed = new Date(texto);
  if (!Number.isNaN(parsed.getTime())) {
    return {
      dia: parsed.getDate(),
      mes: parsed.getMonth() + 1,
      anio: parsed.getFullYear(),
    };
  }

  return null;
}

/** Ej.: "2026-06-01" → "1 días del mes de junio de 2026," */
export function fechaContratoEnLetras(fecha) {
  const partes = parsearFecha(fecha);
  if (!partes) return '';

  const { dia, mes, anio } = partes;
  const mesTexto = MESES[mes - 1];
  if (!mesTexto) return '';

  return `${dia} días del mes de ${mesTexto} de ${anio},`;
}

/** Ej.: "2023-06-01" → "01 de junio del 2023" */
export function fechaContratoEnTexto(fecha) {
  const partes = parsearFecha(fecha);
  if (!partes) return '';

  const { dia, mes, anio } = partes;
  const mesTexto = MESES[mes - 1];
  if (!mesTexto) return '';

  return `${String(dia).padStart(2, '0')} de ${mesTexto} del ${anio}`;
}
